import { createSelector } from '@ngrx/store';
import { selectors } from './settings.reducer';
import { LanguageCode, LanguageIso } from '@mkp/shared/models';

const { selectFeatureState } = selectors;

export const selectInterfaceLanguage = createSelector(
  selectFeatureState,
  ({ language }): LanguageIso | undefined => language
);

export const selectApplicationLanguagePrefix = createSelector(
  selectInterfaceLanguage,
  (lang: LanguageIso | undefined): LanguageCode | undefined => lang?.split('-')[0] as LanguageCode
);

export const selectUsernamePasswordLoginPreferred = createSelector(
  selectFeatureState,
  ({ usernamePasswordLoginPreferred }) => usernamePasswordLoginPreferred
);
